import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type TProps = {
  text: string | number | any;
  isNeedToTranslate?: boolean;
  className?: string;
  textCapitalize?: boolean;
  onClick?: () => void;
};
export const TextColumn: React.FC<TProps> = ({
  text,
  isNeedToTranslate = true,
  className,
  textCapitalize = true,
  onClick,
}) => {
  const { t } = useTranslation();

  const [localText, setLocalText] = useState<string>();

  useEffect(() => {
    if (!isNeedToTranslate) {
      if (typeof text == "string") {
        if (text.length >= 100) {
          setLocalText(text.substring(0, 100) + "....");
        } else {
          setLocalText(text);
        }
      } else {
        setLocalText(text);
      }
    } else {
      setLocalText(text);
    }
  }, [text]);

  return (
    <div
      className="d-flex gap-2 align-items-center"
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      {isNeedToTranslate ? (
        <div
          className={`flex-grow-1 ${
            textCapitalize ? "text-capitalize" : ""
          } ${className}`}
        >
          {t(localText || "-")}
        </div>
      ) : (
        <div
          className={`flex-grow-1 ${
            textCapitalize ? "text-capitalize" : ""
          } ${className}`}
        >
          {localText}
        </div>
      )}
    </div>
  );
};
